import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/js/common/permission'
import * as icons from '@element-plus/icons-vue'
import Viewer from "v-viewer"
import 'viewerjs/dist/viewer.css'
import customcfg from './assets/js/common/conf'
const app=createApp(App);
app.config.globalProperties.ApiUrl = customcfg.ApiUrl;
app.config.globalProperties.ApiModule = customcfg.ApiModule;
import commApi from './assets/js/common/comFun'
for(const apiName in commApi){
    app.config.globalProperties[apiName]=commApi[apiName]
}
for(const iconName in icons){
    app.component(iconName,icons[iconName])
}
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback) {
        callback = debounce(callback,16);
        super(callback);
    }
}
app.use(store).use(router).use(Viewer,{defaultOptions:{zIndex:9999999}}).use(ElementPlus).mount('#app')
